import { render, staticRenderFns } from "./FrsRocket.vue?vue&type=template&id=1d89f1d8&scoped=true&lang=html&"
import script from "./FrsRocket.vue?vue&type=script&lang=js&"
export * from "./FrsRocket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d89f1d8",
  null
  
)

export default component.exports